import dayjs from 'dayjs';
import Csv from "../General/AntComponents/FileTypeIcons/Csv";
import Default from "../General/AntComponents/FileTypeIcons/Default";
import Pdf from "../General/AntComponents/FileTypeIcons/Pdf";
import Upload from '../General/AntComponents/FileTypeIcons/Upload';
import Word from "../General/AntComponents/FileTypeIcons/Word";
import Xls from "../General/AntComponents/FileTypeIcons/Xls";
import { getDayjs } from '../Helpers/TimeFunctions.tsx';

const fmt_currency = (decimals) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: decimals });
export const formatCurrency = (number, decimals) => { return fmt_currency(decimals).format(number); }

export const formatNumberWithComma = (number) => {
    const formattedNumber = number?.toLocaleString('en-US')
    return formattedNumber;
}

export const sortOptions = {
    string: 'string',
    number: 'number',
    date: 'date',
    bool: 'bool'
};

// eslint-disable-next-line no-unused-vars
const sortOn = (array, expr) => {
    return array.sort((a, b) => expr(a) - expr(b));
};


export const sort = (array, expr, dir, sortAs) => {
    let func = stringSort;

    switch (sortAs) {
        case sortOptions.number:
            func = numSort;
            break;
        case sortOptions.date:
            func = dateSort;
            break;
        case sortOptions.bool:
            func = boolSort;
            break;
        default:
            func = stringSort;
    }

    const mult = dir === 'desc' ? -1 : 1;

    return array.sort((a, b) => func(expr(a), expr(b)) * mult);
};

export const stringSort = (a, b) => {
    if (a === null) {
        return 1;
    }

    if (b === null) {
        return -1;
    }
    const aupper = (a || '').toUpperCase();
    const bupper = (b || '').toUpperCase();

    if (aupper < bupper) return -1;
    if (aupper > bupper) return 1;
    return 0;
};

export const dateSort = (a, b) => {
    if (a === null && b !== null) { return -1; }
    if (a !== null && b === null) { return 1; }

    return new Date(a) - new Date(b);
}

export const boolSort = (a, b) => {
    return a === b ? 0 : a ? -1 : 1;
};

export const numSort = (a, b) => {
    return a - b;
};

export const formatWidth = (
    space,
    element,
    vertical,
    className,
) => {
    return new Array(
        !space.isNaN ? space : Array.isArray(space) ? space.length : 4,
    )
        .fill(
            null,
        )
        .map(
            (
                _,
                index,
            ) =>
                element ??
                (vertical ? (
                    <div
                        className={className ?? 'spacer'}
                        key={'spacer-' + index}
                        style={{ height: 2 }}
                    />
                ) : (
                    <span key={'spacer-' + index}>{'\u00A0'}</span>
                )),
        )
}

// export const formatDate = (date: GenericDate, format: string = "MM/DD/YYYY"): string => { // for typescript mike
export const formatDate = (input, locale) => {
    return input ?
        (locale
            ?
            dayjs(new Date(input).toLocaleDateString()).format('MM/DD/YYYY')
            :
            dayjs(input).format("MM/DD/YYYY")
        )
        :
        'N/A'
}

export const formatUTCDate = input => {
    return input ? getDayjs(input).utc().format("MM/DD/YYYY") : "N/A";
}

export const formatTime = (input, utc) => {
    return input ?
        (utc
            ?
            getDayjs(input).utc().format("hh:mm A")
            :
            getDayjs(input).format("hh:mm A")
        )
        :
        "N/A"
}

export const convertToDate = dateTime => {
    return dateTime
        ? getDayjs(dateTime).local().toDate()
        : null;
}

export const removeTime = dateTime => {
    return dateTime
        ? getDayjs(dateTime).startOf('day').toDate()

        : null;
}

export const formatName = (fn, ln) => {
    let firstName = blankNull(fn);
    let lastName = blankNull(ln);

    return firstName === 'aP'
        ? { firstName, lastName: 'User' }
        : { firstName, lastName };
}

const blankNull = input => {
    if (input !== 'NULL' && input !== 'null' && input !== null) return input;
    return '';
}

export const formatInUnits = (input, units, decimals) => {
    const myDecimals = decimals || 0;
    const myUnits = units || "any";

    switch (myUnits) {
        case "K":
            return inUnits(input, 1000, "K", myDecimals);

        case "M":
            return inUnits(input, 1000000, "M", myDecimals);

        case "any":
            if (input > 1000000) return inUnits(input, 1000000, "M", decimals || 2);
            if (input > 1000) return inUnits(input, 1000, "K", decimals || 2);
            return input;

        default:
            return input;
    }
}

const inUnits = (input, divisor, suffix, decimals) => {
    const value = input / divisor;
    return `${value.toFixed(decimals)}${suffix}`;
}

export const limitTextLength = (text, maxLength) => (
    text && text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
);

export const cleanPhoneNumber = phoneNumberString => ('' + phoneNumberString).replace(/\D/g, '');

export const formatPhone = (phoneNumberString) => {
    var cleaned = cleanPhoneNumber(phoneNumberString);
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
}

export const formatSSN = (ssnString) => {
    var cleaned = ('' + ssnString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{2})(\d{4})$/);
    if (match) {
        return '' + match[1] + '-' + match[2] + '-' + match[3];
    }
    return ssnString;
}

export const formatFileIcon = (fileExtension, options) => {
    if (!fileExtension)
        return <Default fontSize={options?.fontSize} fontColor={options?.fontColor} />

    switch (fileExtension) {
        case ".pdf": return <Pdf fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeRed'} />
        case ".csv": return <Csv fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeIvyGreen'} />
        case ".doc": return <Word fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeSteelBlue'} />
        case ".docx": return <Word fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeSteelBlue'} />
        case ".xls": return <Xls fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeIvyGreen'} />
        case ".xlsx": return <Xls fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeIvyGreen'} />
        case "upload": return <Upload fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeSteelBlue'} />
        default: return <Default fontWidth={options?.fontWidth ?? 14} fontColor={options?.fontColor ?? 'fontawesomeGraniteGrey'} />
    }
}

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const formatAddressCityStateZipDisplay = (city, state, zip) => {
    const cleanC = city ? city : '';
    const cleanS = state ? state : '';
    let formatted = cleanC && cleanS ? `${cleanC}, ${cleanS}` : (`${cleanC} ${cleanS}`).trim();
    if (zip) {
        formatted = `${formatted} ${zip}`;
    }
    return formatted.trim();
}

export const formatNameDisplay = (first, middle, last) => {
    const cleanF = first ? first : '';
    const cleanM = middle ? middle : '';
    var formatted = (`${cleanF} ${cleanM}`).trim();
    if (last) {
        formatted = `${formatted} ${last}`;
    }
    return formatted.trim();
}

const orderOfImport = ['Primary', 'Secondary', 'Tertiary', 'Quaternary', 'Quinary', 'Senary', 'Septenary', 'Octonary', 'Nonary', 'Denary'];
export const getInsuranceOrderDescription = index => orderOfImport[index];
